// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8065f8af728665e8af69420d3eeab01ba63820b5/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};